import GtmMixin from 'Mixins/GtmMixin';
import PaymentMethodsMixin from 'Mixins/payments/PaymentMethodsMixin';

import { CANCEL_ORDER_ACTION, RESUME_ORDER_ACTION } from 'Stores/types/userActionsTypes';

import { POPIN_ERROR_EVENT } from 'Classes/Constants';

import ModalOrderResumeOutOfStock from 'Modals/ModalOrderResumeOutOfStock';

import PotagerModal from 'UI/PotagerModal';

import { SALESFORCE_CONTACT_LINK } from 'PotagerLogic/Constants/Salesforce';

export default {
  mixins: [
    PaymentMethodsMixin,
    GtmMixin
  ],

  methods: {
    cancelOrder(order) {
      if (order.isSubscriptionOrder) {
        this.$router.push({
          name: 'mon-compte_order_suspend_form',
          params: {
            orderId: order.id,
          },
        });
      } else {
        const text = order.isPayable
          ? 'Vous êtes sur le point d’annuler votre commande. Sachez que vous pourrez la réactiver au plus tard 2 jours avant la livraison.'
          : 'Si vous avez payé votre commande par carte bancaire vous serez remboursé sous forme de coupon. Si vous avez payé avec des coupons ils vous seront rendus.';
        this.$modal.open(PotagerModal, {
          title: 'Annulation de commande',
          text,
          buttons: [
            {
              label: 'Annuler ma commande',
              loading: CANCEL_ORDER_ACTION,
              action: () => {
                this.$store.dispatch(`user/${CANCEL_ORDER_ACTION}`, { orderId: order.id })
                  .then(() => {
                    this.$modal.open(PotagerModal, {
                      title: 'C\'est tout bon !',
                      text: 'Votre commande a bien été annulée.',
                      buttons: [
                        {
                          label: 'Fermer'
                        }
                      ]
                    });
                  });
              },
            }
          ]
        });
      }
    },
    resumeOrder(orderId, simulation = true, response = null) {
      if (simulation && response) {
        const errors = response.warning;

        if (errors.length > 0 && errors[0].code === 'BT018') {
          const products = errors.filter(warn => warn.code === 'BT018')
            .map(warn => warn.metadata);

          this.$events.emit(POPIN_ERROR_EVENT, {
            component: ModalOrderResumeOutOfStock,
            products,
            orderId,
          });

          return Promise.resolve({
            orderId,
            response
          });
        } else {
          return this.resumeOrder(orderId, false);
        }
      }

      return this.$store.dispatch(`user/${RESUME_ORDER_ACTION}`, {
        id: orderId,
        simulation
      })
        .then(resp => {
          if (!resp.data.success) throw resp.data.errors;

          if (!simulation) {
            const order = resp.data.data.orders.find(o => o.id === orderId);
            if (order) this.notifyOrderStatus(order);
          }

          if (simulation) {
            // nextTick to avoid the no-simulation wait/start to be called before the simulation wait/end
            this.$nextTick(() => this.resumeOrder(orderId, true, resp.data));
          }

          return {
            orderId,
            response: resp.data
          };
        })
        .catch(err => {
          if (!simulation) {
            console.error(err);
            this.$notify({
              type: 'error',
              title: 'Erreur lors de la reprise de la commande',
              text: `Réessayez ou veuillez ${SALESFORCE_CONTACT_LINK} si le problème persiste.`
            });
          }
          throw err;
        });
    }
  },
};
